module.exports = __webpack_public_path__ + "img/cart.5968fe49.svg";